
import { BoxManagementEditPage } from './edit.box';
import { CloudManagementEditPage } from './edit.cloud';
import { DemoManagementEditPage } from './edit.demo';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class ManagementEdit extends mixin(environment.nexus, {
    box: BoxManagementEditPage,
    cloud: CloudManagementEditPage,
    demo: DemoManagementEditPage
}) { }
